import $ from 'jquery';
import datepicker from 'air-datepicker';

const Datepicker = {
    bindEvents: () => {
        const datepickerInput = $('.sib-form__input-datepicker');

        if (datepickerInput.length) {

            Datepicker.init(datepickerInput);
        }

        $('#current-year').html((new Date).getFullYear());
    },

    init: (inputs) => {
        // Create lang config for 'English'
        $.fn.datepicker.language['en'] = {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear',
            dateFormat: 'mm/dd/yyyy',
            timeFormat: 'hh:ii aa',
            firstDay: 1
        };

        let dateToday = new Date();
        let start = $('#sib-form__input-datepicker--start');
        let end = $('#sib-form__input-datepicker--end');
        let startAlt = $('#sib-form__input-datepicker--start-alt');
        let endAlt = $('#sib-form__input-datepicker--end-alt');

        start.datepicker({
            minDate: dateToday,
            autoClose: true,
            language: 'en',
            onShow: function(inst, animationCompleted) {
                if (!animationCompleted) {
                    let bottomEdge = start[0].getBoundingClientRect().bottom;
                    let threshold = $( window ).height() - bottomEdge;
                    if (threshold < 300){
                        inst.update('position', 'top left');
                    } else {
                        inst.update('position', 'bottom left');
                    }
                }
            },
            onSelect: function (fd, date) {
                end.data('datepicker')
                    .update('minDate', date);

                end.focus();
            }
        });
        // start.data('datepicker').selectDate(new Date());

        end.datepicker({
            minDate: dateToday,
            autoClose: true,
            language: 'en',
            onShow: function(inst, animationCompleted) {
                if (!animationCompleted) {
                    let bottomEdge = end[0].getBoundingClientRect().bottom;
                    let threshold = $(window).height() - bottomEdge;
                    if (threshold < 300) {
                        inst.update('position', 'top left');
                    } else {
                        inst.update('position', 'bottom left');
                    }
                }
            },
            onSelect: function (fd, date) {
                start.data('datepicker')
                    .update('maxDate', date)
            }
        });

        startAlt.datepicker({
            minDate: dateToday,
            autoClose: true,
            language: 'en',
            onShow: function(inst, animationCompleted) {
                if (!animationCompleted) {
                    let bottomEdge = startAlt[0].getBoundingClientRect().bottom;
                    let threshold = $(window).height() - bottomEdge;
                    if (threshold < 300) {
                        inst.update('position', 'top left');
                    } else {
                        inst.update('position', 'bottom left');
                    }
                }
            },
            onSelect: function (fd, date) {
                endAlt.data('datepicker')
                    .update('minDate', date);

                endAlt.focus();
            }
        });

        endAlt.datepicker({
            minDate: dateToday,
            autoClose: true,
            language: 'en',
            onShow: function(inst, animationCompleted) {
                if (!animationCompleted) {
                    let bottomEdge = endAlt[0].getBoundingClientRect().bottom;
                    let threshold = $(window).height() - bottomEdge;
                    if (threshold < 300) {
                        inst.update('position', 'top left');
                    } else {
                        inst.update('position', 'bottom left');
                    }
                }
            },
            onSelect: function (fd, date) {
                startAlt.data('datepicker')
                    .update('maxDate', date)
            }
        });

        /*
        inputs.datepicker({
            language: 'en',
            minDate: new Date(),
            autoClose: true,
            onSelect: function(format, date, inst) {
                // update min-max date for related date-fields
                let $el = inst.$el;
                if ($el.hasClass('date-min')) {
                    let $rel = $($el.attr('data-min'));
                    console.log('update min date', $rel.data('datepicker'));
                }
                if ($el.hasClass('date-max')) {
                    let $rel = $($el.attr('data-max'));
                    console.log('update max date', $rel.data('datepicker'));
                }
            }
        });
        */
    }
};

module.exports = Datepicker;



// WEBPACK FOOTER //
// ./src/js/partials/datepicker.js